var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNewProject = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.75V6.25C9.5 6.38807 9.38807 6.5 9.25 6.5H6.5V9.25C6.5 9.38807 6.38807 9.5 6.25 9.5H5.75C5.61193 9.5 5.5 9.38807 5.5 9.25V6.5H2.75C2.61193 6.5 2.5 6.38807 2.5 6.25V5.75C2.5 5.61193 2.61193 5.5 2.75 5.5H5.5V2.75C5.5 2.61193 5.61193 2.5 5.75 2.5H6.25C6.38807 2.5 6.5 2.61193 6.5 2.75V5.5H9.25C9.38807 5.5 9.5 5.61193 9.5 5.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14H22.41C22.1477 13.9989 21.8963 13.8947 21.71 13.71L20.29 12.29C20.1037 12.1053 19.8523 12.0011 19.59 12H12C10.8954 12 10 12.8954 10 14V26C10 27.1046 10.8954 28 12 28H28C29.1046 28 30 27.1046 30 26V16C30 14.8954 29.1046 14 28 14Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewProject, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NewProject.d68ccbc0.svg";
export { ForwardRef as ReactComponent };